import { ReactNode } from 'react';
import { Text } from '@servicetitan/anvil2';
import { section, header } from './SectionLayout.module.css';

interface SectionLayoutProps {
    title: string;
    description?: string;
    children: ReactNode;
}

export const SectionLayout = ({ title, description, children }: SectionLayoutProps) => {
    return (
        <div className={section}>
            <div className={header}>
                <Text variant="headline" size="small" el="h2">
                    {title}
                </Text>
                {description && (
                    <Text variant="body" size="small" subdued>
                        {description}
                    </Text>
                )}
            </div>
            <div>{children}</div>
        </div>
    );
};
